import { AxiosResponse } from "axios";
import { api } from "./base/api";
import { Result } from "../models/common/resultResponse";
import { IInvoiceApi } from "./base";
import { EditInvoiceRequest, SaveProcurementInvoiceRequest } from "../models/request";
import { InvoiceFileResponse, InvoiceResponse } from "../models/response";

const baseRoute: string = "Invoice";

export class InvoiceApi extends IInvoiceApi {
	saveProcurementInvoice(request: SaveProcurementInvoiceRequest): Promise<AxiosResponse<Result<boolean>>> {
		const formattedIssueDate = new Date(request.issueDate).toISOString();

		const url = `saveprocurementinvoice?guidProcurementSupplier=${
			request.guidProcurementSupplier
		}&guidProcurement=${request.guidProcurement}&invoiceNumber=${request.invoiceNumber}&issueDate=${formattedIssueDate}
      ${request.procurementSupplierItemGuids
				.map((item) => {
					return `&procurementSupplierItemGuids=${item}`;
				})
				.join("")}`;

		const formData = new FormData();

		request.uploadFile.forEach((file) => {
			formData.append("uploadFile", file);
		});

		return api.post(`${baseRoute}/${url}`, formData, {
			headers: { "Content-Type": "multipart/form-data" },
		});
	}

	get(guidsProcurementSupplierItem: string[]): Promise<AxiosResponse<Result<InvoiceResponse[]>>> {
		const params = new URLSearchParams();
		guidsProcurementSupplierItem.forEach((item) => params.append("guidsProcurementSupplierItem", item));

		return api.get(`${baseRoute}/get`, { params });
	}

	getinvoicefile(guidInvoice: string): Promise<AxiosResponse<Result<InvoiceFileResponse>>> {
		return api.get(`${baseRoute}/getinvoicefile`, { params: { guidInvoice } });
	}

	editinvoice(request: EditInvoiceRequest): Promise<AxiosResponse<Result<any>>> {
		const formattedIssueDate = new Date(request.issueDate).toISOString();

		const url = `editinvoice?guidInvoice=${request.guidInvoice}&invoiceNumber=${
			request.invoiceNumber
		}&issueDate=${formattedIssueDate}&guidReason=${request.guidReason}
    ${request.reasonDescription ? `&reasonDescription=${request.reasonDescription}` : ""}
    ${
			request.guidFilesToDelete && request.guidFilesToDelete.length > 0
				? request.guidFilesToDelete
						.map((item) => {
							return `&guidFilesToDelete=${item}`;
						})
						.join("")
				: ""
		} `;

		const formData = new FormData();

		if (request.uploadFiles && request.uploadFiles.length > 0) {
			request.uploadFiles.forEach((file) => {
				formData.append("uploadFiles", file);
			});
		}

		return api.put(`${baseRoute}/${url}`, formData, {
			headers: { "Content-Type": "multipart/form-data" },
		});
	}

	getfilebyguidinvoicefile(guidInvoiceFile: string): Promise<AxiosResponse<Result<InvoiceFileResponse>>> {
		return api.get(`${baseRoute}/getfilebyguidinvoicefile`, {
			params: { guidInvoiceFile },
		});
	}
}
